<div class="container mb-5">
  <div class="row my-4">
    <div class="col-md-1 align-self-center">
      <button id="account-back-btn" type="button" class="button ghost__button icon__left p-0"
        [routerLink]="['/dashboard']">
        <em class="fa fa-arrow-left"></em>
        Back
      </button>
    </div>
    <div class="col-md-6 col-9">
      <div class="font-size-40 font-weight-bold" *ngIf="isUserInfo">Account Settings</div>
      <!-- <div class="font-size-40 font-weight-bold" *ngIf="isPricing">Pricing plans</div>
      <div class="font-size-40 font-weight-bold" *ngIf="isIntegrations">Integrations</div> -->
    </div>
    <div class="col-md-5 col-3 mobile-adjustment">
      <!-- <button type="button" class="button icon__button" [class.active__btn]="isUserInfo"
        (click)="isUserInfo = true; isPricing = false; isIntegrations = false;">
        <svg-icon name="user-blue-icon" *ngIf="isUserInfo"></svg-icon>
        <svg-icon name="user-light-blue-icon" *ngIf="!isUserInfo"></svg-icon>
      </button>
      <button type="button" class="button icon__button" [class.active__btn]="isPricing"
        (click)="isUserInfo = false; isPricing = true; isIntegrations = false;">
        <svg-icon name="pricing-plan-blue-icon" *ngIf="isPricing"></svg-icon>
        <svg-icon name="pricing-plan-light-blue-icon" *ngIf="!isPricing"></svg-icon>
      </button>
      <button type="button" class="button icon__button" [class.active__btn]="isIntegrations"
        (click)="isIntegrations = true; isPricing = false; isUserInfo = false;">
        <svg-icon name="integration-blue-icon" *ngIf="isIntegrations"></svg-icon>
        <svg-icon name="integration-light-blue-icon" *ngIf="!isIntegrations"></svg-icon>
      </button> -->
      <button id="save-all-changes" type="button" (click)="saveAllChanges()"
        class="button primary__button action__button" [disabled]="isPricing">
        <span class="desktop-text">Save changes</span>
        <em class="fa fa-floppy-o mobile-button-icon"></em>
      </button>
    </div>
  </div>

  <!-- <ng-container *ngIf="showNotification && user && isUserInfo">
    <div class="no__subscription__notification mb-5">
      <svg-icon name="Credit_Card" svgClass="mr-12"></svg-icon>
      <div class="w-100">
        You have no subscription plans. <span class="buy"
          (click)="isUserInfo = false; isPricing = true; isIntegrations = false;">Select subscription plan</span> to
        to get more opportunities.
      </div>
        <svg-icon name="Close_Status" (click)="showNotification = false;"></svg-icon>
    </div>
  </ng-container> -->

  <div class="row mt-5" *ngIf="user && isUserInfo">
    <div class="col-lg-10 col-md-12">
      <div class="row">
        <div class="col-md-6">
          <h5 class="font-weight-bold">Personal Information</h5>
        </div>
        <!-- <div class="col-md-6" *ngIf="user?.isOrganization">
          <h5 class="m-0 font-weight-bold">Organization settings</h5>
          <small class="text-muted">Managed by Straighten Oakmand Administrator</small>
        </div> -->
      </div>

      <form #userForm="ngForm" novalidate="novalidate" autocomplete="off">

        <ng-container>

          <div class="row">
            <div class="col-lg-6 col-md-12 mobile-buttons">
              <img [src]="imageSrc" onerror="this.src='../../../assets/images/profilePhoto.jpg';" (error)="noImage=true"
                alt="..." class="rounded-circle" width="70" height="70">

              <div class="upload">
                <ngx-file-drop (onFileDrop)="uploadPhoto($event)" (onFileOver)="fileOver($event)"
                  (onFileLeave)="fileLeave($event)" accept="image/*" multiple="false">
                  <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                    <button id="account-change-photo" type="button" class="button secondary__button large__button"
                      (click)="openFileSelector()">Change photo</button>
                  </ng-template>
                </ngx-file-drop>
              </div>

              <button id="account-delete-photo" type="button" class="button large__button delete__mage__btn"
                (click)="deleteProfilePhoto()" [disabled]="noImage">
                <span class="desktop-text">Delete photo</span>
                <em class="fa fa-trash mobile-button-icon"></em>
              </button>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-6">
              <div class="form-group">
                <small class="m-0 text-muted">Email</small>
                <input type="text" id="account-email-text" class="input input__blue input__large" disabled
                  [(ngModel)]="user.EMAIL" #EMAIL="ngModel" name="EMAIL">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" *ngIf="user.isOrganization">
                <small class="m-0 text-muted">Organization</small>
                <input id="account-organization-text" type="text" class="input input__blue input__large"
                  [(ngModel)]="user.ORGANIZATION.NAME" #ORGANIZATION_NAME="ngModel" name="ORGANIZATION_NAME"
                  placeholder="Organization Name" [disabled]="!userService.checkOrganizationAdmin()">
              </div>
              <div class="form-group" *ngIf="!user.isOrganization">
                <small class="m-0 text-muted">Company</small>
                <input id="account-organization-text" type="text" class="input input__blue input__large"
                  [(ngModel)]="user.COMPANY" #COMPANY="ngModel" name="COMPANY" placeholder="Company Name">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <small class="m-0 text-muted">First name</small>
                <input type="text" restrictFirstSpace appAlphabetWithSpaceOnly id="account-first-name"
                  class="input input__blue input__large" [(ngModel)]="user.NAME_FIRST" #NAME_FIRST="ngModel"
                  name="NAME_FIRST" maxlength="30"
                  [ngClass]="{'input__error': (NAME_FIRST.errors && (NAME_FIRST.dirty || NAME_FIRST.touched))}"
                  required>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <small class="m-0 text-muted">Last name</small>
                <input type="text" restrictFirstSpace appAlphabetWithSpaceOnly id="account-last-name"
                  class="input input__blue input__large" [(ngModel)]="user.NAME_LAST" #NAME_LAST="ngModel"
                  name="NAME_LAST" maxlength="30"
                  [ngClass]="{'input__error': (NAME_LAST.errors && (NAME_LAST.dirty || NAME_LAST.touched))}" required>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <small class="m-0 text-muted">Address</small>
                <input type="text" restrictFirstSpace id="account-address-text" class="input input__blue input__large"
                  [(ngModel)]="user.ADDRESS" #ADDRESS="ngModel" name="ADDRESS" maxlength="150"
                  [ngClass]="{'input__error': (ADDRESS.errors && (ADDRESS.dirty || ADDRESS.touched))}" required
                  [disabled]="userService.isOrganizationUser() && !userService.checkOrganizationAdmin()">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-0">
                <small class="m-0 text-muted">Phone Number</small>
                <input type="text" id="account-phone-number" phoneNumber class="input input__blue input__large"
                  [(ngModel)]="user.TELEPHONE" #TELEPHONE="ngModel" name="TELEPHONE" placeholder="000 000 0000">
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <small class="m-0 text-muted">Zip</small>
                <input type="text" id="account-zip" class="input input__blue input__large" maxlength="5" minlength="5"
                  (keyup)="zipEntered()" (keypress)="_keyPress($event)" [(ngModel)]="user.ZIP" #ZIP="ngModel" name="ZIP"
                  [ngClass]="{'input__error': (ZIP.errors && (ZIP.dirty || ZIP.touched))}" required
                  [disabled]="userService.isOrganizationUser() && !userService.checkOrganizationAdmin()">
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <small class="m-0 text-muted">City</small>
                <input type="text" id="account-city" class="input input__blue input__large" [(ngModel)]="user.CITY"
                  #CITY="ngModel" name="CITY" disabled>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group mb-0">
                <small class="m-0 text-muted">State</small>
                <input type="text" id="account-state" class="input input__blue input__large" [(ngModel)]="user.STATE"
                  #STATE="ngModel" name="STATE" disabled>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-6">
              <button type="button" id="account-change-password" class="button secondary__button large__button"
                (click)="changePassword()">
                Change password
              </button>
            </div>
          </div>

        </ng-container>

      </form>

      <div class="row my-4">
        <div class="col-md-12">
          <label class="checkbox large">
            <input class="checkbox__input" type='checkbox' id="skipCheck" [(ngModel)]="showCriteria"
              (click)="skipIntroduction(!$event.target.checked)" />
            <div class="checkbox__data">
              <div class="checkbox__indicator"></div>
              <p class="checkbox__text">
                Show Criteria Screen?
              </p>
            </div>
          </label>
        </div>
      </div>

    </div>
  </div>

  <div class="mt-5" *ngIf="isPricing">
    <app-pricing-plans></app-pricing-plans>
  </div>

  <div class="qb__section mt-5" *ngIf="isIntegrations">

    <div class="list-container">
      <!-- <div class="row mt-4 list-header">
        <div class="col-md-1 item"></div>
        <div class="col-md-3 item">Name</div>
        <div class="col-md-3 item">Email</div>
        <div class="col-md-2 item">Access</div>
        <div class="col-md-1 item">Status</div>
        <div class="col-md-2 item"></div>
      </div> -->
      <div class="list-body">
        <div class="row item align-items-center py-4" *ngFor="let qb of integrationList">
          <div class="col-md-1">
            <img src="../../../assets/images/qb-green-icon.png" width="50" alt="...">
          </div>
          <div class="col-md-9">
            <div class="title">{{qb.title}}</div>
            <div class="color-secondary-gray">{{qb.desc}}</div>
          </div>
          <div class="col-md-2 text-right">
            <button class="button secondary__button medium__button" *ngIf="!qb.isConnected">Сonnect</button>
            <button class="button primary__button medium__button" *ngIf="qb.isConnected">
              <img alt="..." src="../../../assets/images/white-right-icon.svg" class="mr-2">
              Сonnected
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
